import Ajax from '../ajax';

export default {
  list: () => Ajax('get', 'swapout/productTag'),
  get: (tagId) => Ajax('get', `swapout/productTag/${tagId}`),
  add: (data) => Ajax('post', 'swapout/productTag', data),
  edit: (tagId, data) => Ajax('put', `swapout/productTag/${tagId}`, data),
  delete: (tagId) => Ajax('delete', `swapout/productTag/${tagId}`),
  applyProductList: (tagId, filter) => Ajax('get', `swapout/productTag/${tagId}/applyProduct`, filter),
  deleteApplyProduct: (tagId, productId) => Ajax('delete', `swapout/productTag/${tagId}/applyProduct/${productId}`),
};
